module.exports = __webpack_public_path__ + "static/14-colour-67b0b8a442c3b3126139a512d683562a.jpg";